import { call, select, put } from 'redux-saga/effects';
import API from "../../API";
import {loadFiltersError, loadFiltersSuccess} from "../filters/filters-action-creators";
import {normalizeFilters} from "./normalizeFilters";
import {sortFilters} from "./functions";
import deepCopy from "../../utilities/deepCopy";

export function* loadFiltersRequest() {

  const reportUrl = yield select(state => state.report.reportUrl);

  try {
    const { data } = yield call(API.loadFilters, { reportUrl });
    console.log(data, 'RESULT FROM LOAD FILTERS')
    if (data && data.length) {
      const normalized = normalizeFilters(deepCopy(data));
      yield put(loadFiltersSuccess(normalized));
    } else {
      yield put(loadFiltersError("No data"));
    }

  } catch(error) {
    yield put(loadFiltersError("Something went wrong..."))
  }
}


// WEBPACK FOOTER //
// ./src/modules/filters/load-filters-saga.js